// import external dependencies
// import 'jquery';
// import 'bootstrap';
// import 'bootstrap/js/src/util';
// import 'bootstrap/js/src/collapse';
// import 'bootstrap/js/src/tab';
// import 'bootstrap/js/src/modal';

import ready from './util/ready';
import {enableLog} from "./util/logger";

if ('development' === process.env.NODE_ENV) {
  enableLog('Norrtåg Global: ');
}

import Menu from './modules/Menu';
import googleTranslate from "./blocks/googleTranslate";
import booking from "./blocks/booking";
import Sidebar from "./modules/Sidebar";

Menu();
Sidebar();

ready(() => {
  googleTranslate();
  booking();
});
